import { Slider as MuiSlider, SliderProps } from "@mui/material";
import { Box, SxProps } from "@mui/system";
import { useState } from "react";

import { theme } from "../mui-customs/Theme";
import ErrorMessage from "./ErrorMessage";
import Typography from "./Typography";

interface ExtendedSliderProps extends SliderProps {
  label: string;
  handleOnChange?: (value: number | number[]) => void;
  containerSx?: SxProps;
  isRequired?: boolean;
  maxValue: number;
  minValue: number;
  maxValueLabel: string;
  minValueLabel: string;
  error?: boolean;
  helperText?: string;
}

const Slider = ({
  sx,
  label,
  handleOnChange,
  isRequired,
  maxValue,
  minValue,
  defaultValue,
  maxValueLabel,
  minValueLabel,
  containerSx,
  error,
  helperText,
  ...props
}: ExtendedSliderProps) => {
  const [value, setValue] = useState(defaultValue);
  const handleChange = (e: Event, value: number | number[]) => {
    handleOnChange && handleOnChange(value);
    typeof value === "number" && setValue(value);
  };
  return (
    <Box
      sx={{
        width: { xs: "100%" },
        mx: { xs: "none" },
        mb: 3,
        ...containerSx,
      }}
    >
      <Typography variant="body2">
        {label}
        {isRequired && (
          <Box component="span" sx={{ color: theme.red[500] }}>
            *
          </Box>
        )}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="body2">{minValueLabel}</Typography>
        <MuiSlider
          sx={{
            height: "5px",
            "& .MuiSlider-rail": {
              backgroundColor: theme.grey2[150],
              borderRadius: "3px",
            },
            "& .MuiSlider-track": {
              backgroundColor: theme.brand1[500],
            },
            "& .MuiSlider-thumb:before": {
              backgroundColor: theme.brand1[500],
              border: `4px solid ${theme.whiteBg.WBG1}`,
              height: "16px",
              width: "16px",
            },
            "& .MuiSlider-valueLabel": {
              backgroundColor: "transparent",
              color: theme.grey2[400],
              fontSize: "14px",
              top: "55px",
            },
          }}
          {...props}
          value={value}
          onChange={handleChange}
          valueLabelDisplay="on"
          max={maxValue}
          min={minValue}
        />
        <Typography variant="body2">{maxValueLabel}</Typography>
      </Box>
      {error && !props.value && (
        <ErrorMessage sx={{ mt: 4 }} message={helperText} />
      )}
    </Box>
  );
};

export default Slider;
